<template>
    <el-dialog
        class="edit-express-rule"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        :modal-append-to-body="false"
        append-to-body
        width="650px"
        title="Set Express Rule"
    >
        <!-- <div class="tip">
            <i class="el-icon-warning"></i>
            <p>
                Tip:After account authorization is successful,the first
                synchronization
            </p>
        </div> -->
        <el-form
            ref="editForm"
            :model="editForm"
            :rules="rules"
            label-width="100px"
        >
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item
                        label="Express"
                        prop="last_mile"
                        size="small"
                    >
                        <!-- <el-input
                            clearable
                            placeholder="Please input"
                            maxlength="100"
                            size="small"
                            v-model="editForm.express"
                        >
                        </el-input> -->
                        <el-select
                            clearable
                            filterable
                            v-model="editForm.last_mile"
                            placeholder="Please select"
                        >
                            <el-option
                                v-for="item in channelList"
                                :key="item.id"
                                :label="item.last_mile"
                                :value="item.last_mile"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="Type"
                        prop="type"
                        size="small"
                    >
                        <el-select
                            clearable
                            filterable
                            v-model="editForm.type"
                            placeholder="Please select"
                        >
                            <el-option
                                v-for="item in typeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="editForm.type == 2">
                    <el-form-item label="Users" size="small" prop="specify_user" required>
                        <tagsInput
                            :tagsList.sync="editForm.specify_user"
                            title="Users"
                            :visible="editVisible"
                        ></tagsInput>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Weight" prop="weight" size="small">
                        <el-row
                            :gutter="0"
                            v-for="(item, index) in editForm.value"
                            :key="index"
                        >
                            <el-col :span="6">
                                <el-input
                                    size="small"
                                    placeholder="Weight Min"
                                    v-model="item.weight_min"
                                ></el-input>
                            </el-col>

                            <el-col :span="6" :offset="1">
                                <el-input
                                    size="small"
                                    placeholder="Weight Max"
                                    v-model="item.weight_max"
                                ></el-input>
                            </el-col>
                            <el-col :span="6" :offset="1">
                                <el-input
                                    size="small"
                                    placeholder="Price"
                                    v-model="item.price"
                                ></el-input>
                            </el-col>
                            <el-col :span="3" :offset="1">
                                <el-button
                                    v-if="index < 1"
                                    type="text"
                                    size="mini"
                                    icon="el-icon-plus"
                                    @click="addItems"
                                ></el-button>
                                <el-button
                                    type="text"
                                    size="mini"
                                    icon="el-icon-minus"
                                    @click="minusItems(index)"
                                ></el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Country" prop="country" size="small">
                        <!-- <el-input
                            clearable
                            placeholder="Please input"
                            maxlength="100"
                            size="small"
                            v-model="editForm.country"
                            type="textarea"
                            resize="none"
                            :autosize="{ minRows: 6, maxRows: 10 }"
                        >
                        </el-input> -->
                        <el-select
                            filterable
                            multiple
                            v-model="editForm.country"
                            placeholder="Please select"
                            @change="changeFn"
                        >
                            <el-option
                                v-for="item in countryList"
                                :key="item.id"
                                :label="item.name_en"
                                :value="String(item.id)"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="Delivery" prop="delivery" size="small">
                        <el-input
                            v-model="editForm.delivery"
                            placeholder="Please input"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
import tagsInput from "@/common/components/tags-input";
export default {
    data() {
        let checkWeight = (rule, value, callback) => {
            if (Object.values(this.editForm.value[0]).some((item) => !item)) {
                return callback(new Error("weight is required"));
            } else {
                callback();
            }
        };
        let checkType = (rule, value, callback) => {
            if (this.editForm.type == 2 && value == '') {
                return callback(new Error("specify_user is required"));
            } else {
                callback();
            }
        };
        return {
            editForm: {
                last_mile: "",
                country: "",
                type: "",
                value: [{
                    weight_min: "",
                    weight_max: "",
                    price: "",
                }],
                delivery: '',
                specify_user: [],
            },
            rules: {
                last_mile: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                weight: [
                    {
                        required: true,
                        validator: checkWeight,
                        trigger: "blur",
                    },
                ],
                country: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                specify_user: [
                    {
                        required: false,
                        validator: checkType,
                        trigger: "blur",
                    },
                ],
            },
            countryList: [],
            channelList: [],
            typeList: [
                {
                    id: 1,
                    name: "Regular"
                },{
                    id: 2,
                    name: "Specify User"
                },
            ]
        };
    },
    methods: {
        ...mapActions(["getCountrySelect", "getExpressSelect"]),
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        /**
         *  保存
         */
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    cmofferApi
                        .expressList(
                            {
                                ...this.editForm,
                                country: this.editForm.country.join(",")
                            },
                            "post",
                            this.tableItem.uuid
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        expressList() {
            cmofferApi
                .expressList({}, "get", this.tableItem.uuid)
                .then((res) => {
                    if (res) {
                        this.editForm = { ...res.data };
                        this.editForm.country = res.data.country.split(",");
                    }
                });
        },
        addItems() {
            this.editForm.value.push({
                weight_min: "",
                weight_max: "",
                price: "",
            });
        },
        minusItems(index) {
            /* if (this.weightList.length <= 1) return;
            this.weightList.splice(index, 1); */
            if (this.editForm.value.length <= 1) return;
            this.editForm.value.splice(index, 1);
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String
    },
    components: {
        tagsInput
    },
    watch: {
        editVisible(val) {
            if (val) {
                this.expressList();
                this.getCountrySelect().then((res) => {
                    this.countryList = res.data;
                });
                cmofferApi
                .lastMileSelect({}, "get")
                .then((res) => {
                    if (res) {
                        this.channelList = res.data;
                    }
                });
            }
        },
    },
};
</script>
<style lang="scss">
.edit-express-rule {
    .el-form-item__content {
        .el-select,
        .el-select--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
    .el-row {
        /* &:not(:last-child) {
            margin-bottom: 18px;
        } */
        &:only-child {
            margin-bottom: 0;
        }
        & + .el-row {
            margin-top: 18px;
        }
    }
    .tip {
        padding: 8px 20px;
        font-size: 12px;
        color: #333;
        background-color: #e6f7ff;
        border: 1px solid #bee6ff;
        border-radius: 4px;
        align-self: center;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        i.el-icon-warning {
            margin-right: 10px;
            color: #1890ff;
            font-size: 16px;
        }
    }
}
</style>
